import React from 'react'
import { useIntl } from 'react-intl'
import LineTagAltIcon from 'LuxKit/Icons/line/LineTagAltIcon'
import LineGlassMartiniAltIcon from 'LuxKit/Icons/line/LineGlassMartiniAltIcon'
import LineGlobeAltIcon from 'LuxKit/Icons/line/LineGlobeAltIcon'
import LineClockDollarIcon from 'LuxKit/Icons/line/LineClockDollarIcon'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import LineParcelIcon from 'LuxKit/Icons/line/LineParcelIcon'
import LineUserPlusIcon from 'LuxKit/Icons/line/LineUserPlusIcon'
import LineUsdCircleIcon from 'LuxKit/Icons/line/LineUsdCircleIcon'

const tagIcon = <LineTagAltIcon size="L" />
const martiniIcon = <LineGlassMartiniAltIcon size="L" />
const globeIcon = <LineGlobeAltIcon size="L" />
const clockDollarIcon = <LineClockDollarIcon size="L" />
const phoneIcon = <LinePhoneIcon size="L" />
const parcelIcon = <LineParcelIcon size="L" />
const userPlusIcon = <LineUserPlusIcon size="L" />
const usdCircleIcon = <LineUsdCircleIcon size="L" />

export interface WhyBookWithUsItem {
  key: string
  Icon: React.ReactElement
  heading: string
  body: string
  link?: {
    text: string
    to?: string
    href?: string
  }
}

export function useWhyBookWithUsContent(): Array<WhyBookWithUsItem> {
  const intl = useIntl()

  return [
    {
      key: 'save-up-to-70',
      Icon: tagIcon,
      heading: intl.formatMessage({
        id: '2s9IB7bocx',
        defaultMessage: 'Save up to 70% off',
        description: 'Why book with us - save up to 70% heading',
      }),
      body: intl.formatMessage({
        id: 'GOPNjZR3mW',
        defaultMessage: 'We negotiate directly with our travel partners to secure exclusive offers you won’t find elsewhere.',
        description: 'Why book with us - save up to 70% body text',
      }),
      link: {
        text: intl.formatMessage({
          id: 'ujfgr1Mguc',
          defaultMessage: 'Browse offers',
          description: 'Why book with us - link to browse travel offers',
        }),
        to: '/',
      },
    },
    {
      key: 'bonus-vip-inclusions',
      Icon: martiniIcon,
      heading: intl.formatMessage({
        id: 'udAT6jP0Xj',
        defaultMessage: 'Bonus VIP inclusions',
        description: 'Why book with us - bonus VIP inclusions heading',
      }),
      body: intl.formatMessage({
        id: 'HPDSbTrJNU',
        defaultMessage: 'Handpicked inclusions and exclusive extras will make your trip even more memorable.',
        description: 'Why book with us - bonus VIP inclusions body text',
      }),
    },
    {
      key: 'one-stop-destination',
      Icon: globeIcon,
      heading: intl.formatMessage({
        id: 'FWTNL1ns4i',
        defaultMessage: 'One-stop destination',
        description: 'Why book with us - one-stop destination heading',
      }),
      body: intl.formatMessage({
        id: 'l4B2uMKybk',
        defaultMessage: 'Discover 1,000s of flights, hotels, packages, tours, cruise, experiences, car hire & more.',
        description: 'Why book with us - one-stop destination body text',
      }),
    },
    {
      key: 'flexible-bookings',
      Icon: clockDollarIcon,
      heading: intl.formatMessage({
        id: 'adGsd8tjCT',
        defaultMessage: 'Flexible bookings',
        description: 'Why book with us - flexible bookings heading',
      }),
      body: intl.formatMessage({
        id: 'qSvg02bKek',
        defaultMessage: 'Travel with peace of mind with our flexible cancellation policies.',
        description: 'Why book with us - flexible bookings body text',
      }),
    },
    {
      key: 'customer-service',
      Icon: phoneIcon,
      heading: intl.formatMessage({
        id: 'kGBybPdHnx',
        defaultMessage: '24/7 customer service',
        description: 'Why book with us - customer service heading',
      }),
      body: intl.formatMessage({
        id: 'RnYV245yr0',
        defaultMessage: 'Regardless of your time zone, we offer round-the-clock service.',
        description: 'Why book with us - customer service body text',
      }),
    },
    {
      key: 'local-travel-guides',
      Icon: parcelIcon,
      heading: intl.formatMessage({
        id: 'b8u8NL69cC',
        defaultMessage: 'Local travel guides and inspiration',
        description: 'Why book with us - local travel guides heading',
      }),
      body: intl.formatMessage({
        id: '0WQcjC0vG3',
        defaultMessage: 'Be inspired by expert recommendations and local travel tips.',
        description: 'Why book with us - local travel guides body text',
      }),
      link: {
        text: intl.formatMessage({
          id: '/XwbMqNgMG',
          defaultMessage: 'Get inspired',
          description: 'Why book with us - link to travel inspiration content',
        }),
        href: 'https://luxuryescapes.com/inspiration',
      },
    },
    {
      key: 'refer-a-friend',
      Icon: userPlusIcon,
      heading: intl.formatMessage({
        id: '3HsPYTde1C',
        defaultMessage: 'Refer a friend',
        description: 'Why book with us - refer a friend heading',
      }),
      body: intl.formatMessage({
        id: '4Bvrqux3bO',
        defaultMessage: 'Refer a friend and you’ll both receive credit towards your next escape.',
        description: 'Why book with us - refer a friend body text',
      }),
      link: {
        text: intl.formatMessage({
          id: 'CsC/0fJ62K',
          defaultMessage: 'Learn more',
          description: 'Why book with us - link to refer a friend page',
        }),
        to: '/refer',
      },
    },
    {
      key: 'best-price-guarantee',
      Icon: usdCircleIcon,
      heading: intl.formatMessage({
        id: '45Wgi84fhX',
        defaultMessage: 'Best price guarantee',
        description: 'Why book with us - best price guarantee heading',
      }),
      body: intl.formatMessage({
        id: '04MrR3Kvf7',
        defaultMessage: 'In the unlikely event that you find a better price for the same offer, we promise to match it.',
        description: 'Why book with us - best price guarantee body text',
      }),
      link: {
        text: intl.formatMessage({
          id: 'XBwsMwyAax',
          defaultMessage: 'Learn more',
          description: 'Why book with us - link to best price guarantee page',
        }),
        to: '/best-price-guarantee',
      },
    },
  ]
}
